"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fmoney = fmoney;
exports.format = format;
exports.formatDate = formatDate;
Object.defineProperty(exports, "formatTime", {
  enumerable: true,
  get: function get() {
    return _utils.formatTime;
  }
});
exports.numberFormatter = numberFormatter;
Object.defineProperty(exports, "parseTime", {
  enumerable: true,
  get: function get() {
    return _utils.parseTime;
  }
});
exports.timeAgo = timeAgo;
exports.toThousandFilter = toThousandFilter;
exports.uppercaseFirst = uppercaseFirst;
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.regexp.constructor");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.number.constructor");
var _utils = require("@/utils");
// import parseTime, formatTime and set to filter

/**
 * Show plural label if time is plural number
 * @param {number} time
 * @param {string} label
 * @return {string}
 */
function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }
  return time + label + 's';
}

/**
 * @param {number} time
 */
function timeAgo(time) {
  var between = Date.now() / 1000 - Number(time);
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute');
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour');
  } else {
    return pluralize(~~(between / 86400), ' day');
  }
}

/**
 * Number formatting
 * like 10000 => 10k
 * @param {number} num
 * @param {number} digits
 */
function numberFormatter(num, digits) {
  var si = [{
    value: 1E18,
    symbol: 'E'
  }, {
    value: 1E15,
    symbol: 'P'
  }, {
    value: 1E12,
    symbol: 'T'
  }, {
    value: 1E9,
    symbol: 'G'
  }, {
    value: 1E6,
    symbol: 'M'
  }, {
    value: 1E3,
    symbol: 'k'
  }];
  for (var i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol;
    }
  }
  return num.toString();
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
function toThousandFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, function (m) {
    return m.replace(/(?=(?!\b)(\d{3})+$)/g, ',');
  });
}

/**
 * Upper case first char
 * @param {String} string
 */
function uppercaseFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * yyyy-MM-dd
 * @param {number} time
 */
function formatDate(data) {
  if (data) {
    var date = new Date(data);
    var o = {
      "M+": date.getMonth() + 1,
      //月份 
      "d+": date.getDate(),
      //日 
      "h+": date.getHours(),
      //小时 
      "m+": date.getMinutes(),
      //分 
      "s+": date.getSeconds(),
      //秒 
      "q+": Math.floor((date.getMonth() + 3) / 3),
      //季度 
      "S": date.getMilliseconds() //毫秒 
    };
    var fmt = "yyyy-MM-dd";
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
      if (new RegExp("(" + k + ")").test(fmt)) {
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
      }
    }
    return fmt;
  } else {
    return "";
  }
}
function format(date, format) {
  if (!date) {
    return '';
  }
  var d = new Date(date);

  // 年
  if (/YYYY/.test(format)) {
    format = format.replace(/YYYY/, d.getFullYear());
  }
  // 月份
  var month = d.getMonth() + 1;
  if (/MM/.test(format)) {
    var monthStr = month < 10 ? '0' + month : month;
    format = format.replace(/MM/, monthStr);
  } else if (/M/.test(format)) {
    format = format.replace(/M/, month);
  }
  // 日期
  var dates = d.getDate();
  if (/DD/.test(format)) {
    var dateStr = dates < 10 ? '0' + dates : dates;
    format = format.replace(/DD/, dateStr);
  } else if (/D/.test(format)) {
    format = format.replace(/D/, dates);
  }
  // 小时
  var hours = d.getHours();
  if (/HH/.test(format)) {
    var hoursStr = hours < 10 ? '0' + hours : hours;
    format = format.replace(/HH/, hoursStr);
  } else if (/H/.test(format)) {
    format = format.replace(/H/, hours);
  } else if (/hh/.test(format)) {
    var hoursMin = hours > 12 ? hours - 12 : hours;
    var _hoursStr = hoursMin < 10 ? '0' + hoursMin : hoursMin;
    format = format.replace(/hh/, _hoursStr);
  } else if (/h/.test(format)) {
    var _hoursMin = hours > 12 ? hours - 12 : hours;
    format = format.replace(/h/, _hoursMin);
  }
  // 分
  var minutes = d.getMinutes();
  if (/mm/.test(format)) {
    var minutesStr = minutes < 10 ? '0' + minutes : minutes;
    format = format.replace(/mm/, minutesStr);
  } else if (/m/.test(format)) {
    format = format.replace(/m/, minutes);
  }
  // 秒
  var seconds = d.getSeconds();
  if (/ss/.test(format)) {
    var secondsStr = seconds < 10 ? '0' + seconds : seconds;
    format = format.replace(/ss/, secondsStr);
  } else if (/s/.test(format)) {
    format = format.replace(/s/, seconds);
  }
  return format;
}

/**
 * @param {String} money
 */
function fmoney(s) {
  var ind = 0;
  if (s < 0) {
    s = Math.abs(s);
    ind = 1;
  }
  var n;
  var t;
  if (s === 0 || s) {
    n = 2;
    s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
    var l = s.split(".")[0].split("").reverse(),
      r = s.split(".")[1];
    t = "";
    for (var i = 0; i < l.length; i++) {
      t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? "," : "");
    }
    var str = ind == 1 ? "-" + t.split("").reverse().join("") + "." + r : t.split("").reverse().join("") + "." + r;
    return str;
  } else {
    return "0.00";
  }
}